export default {
  storeDocumentList(state, documents) {
    state.documents = documents;
  },
  storeDocument(state,document) {
    state.document = document
  },
  storeUpdatedDocument(state,updatedDocument) {
    state.document = updatedDocument
  },
  storeCreatedDocument(state,createdDocument) {
    state.documents << createdDocument
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/folders/mutations.js